"use client";

import { AppleIcon } from "@/components/common/add-to-calendar/apple-icon";
import { GoogleIcon } from "@/components/common/add-to-calendar/google-icon";
import { OutlookIcon } from "@/components/common/add-to-calendar/outlook-icon";
import { addToCalendarAction } from "@/components/common/add-to-calendar/service";
import { Button } from "@/components/ui/button";
import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog";
import { ResourceContext } from "@/contexts/resource-context";
import { useContext } from "react";

export const PracticeExamAddToCalendarDialog = ({
  isOpen,
  setOpen,
  dateToAdd,
  startTime,
  endTime,
}: {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  dateToAdd: Date;
  startTime: string;
  endTime: string;
}) => {
  const options = ["Apple", "Google", "Outlook.com"] as const;
  const { logView } = useContext(ResourceContext);

  const mapIcon = {
    Google: <GoogleIcon />,
    "Outlook.com": <OutlookIcon />,
    Apple: <AppleIcon />,
  };

  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-[80vw] bg-white xl:max-w-[336px]"
        innerClassName={`p-6`}
      >
        <h3 className={"mb-4 text-lg font-semibold"}>
          Dodaj Próbny LEK do kalendarza
        </h3>
        <div className={"flex items-center justify-center gap-4"}>
          {options.map((option) => (
            <Button
              variant={"outline"}
              size={"icon"}
              key={option}
              className={"m-0"}
              onClick={() =>
                addToCalendarAction(
                  option,
                  {
                    name: "Próbny LEK z Remedium",
                    startDate: dateToAdd.toISOString().split("T")[0],
                    endDate: dateToAdd.toISOString().split("T")[0],
                    startTime,
                    endTime,
                  },
                  logView,
                  setOpen,
                )
              }
            >
              {mapIcon[option]}
            </Button>
          ))}
        </div>
        <DialogClose />
      </DialogContent>
    </Dialog>
  );
};
